import React from "react";

const ComingSoon = () => {

    return (
        <div style={{
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
        }}>

            <img alt={'coming soon'} src={'/images/coming_soon.png'} style={{width: 400}}/>
        </div>
    );
};
export default ComingSoon;